//============================================================================
// Redux
//============================================================================
export enum LocationsActions {
  StoreInitialState,

  // Location
  LocationUpdate,

  // Contact
  ContactCreate,
  ContactUpdate,
  ContactDestroy,

  // HolidayHour
  HolidayHourCreate,
  HolidayHourUpdate,
  HolidayHourDestroy,

  // RequirementField
  RequirementFieldCreate,
  RequirementFieldUpdate,
  RequirementFieldDestroy,
}

//============================================================================
// Add Component
//============================================================================
// export interface IAddProps {
//     code: string,
//     itemNumber: string;
//     inStock: number;
//     description: string;

//     setInventoryRequest: (payload?: any) => void;
// }
